'use client'

import { Cell, Icon } from '@vinted/web-ui'
import { Flag24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import ConversationExample from '../../ConversationExample'
import TimerProgressBar from '../../TimerProgressBar/TimerProgressBar'
import { getDurationForExample } from '../../../../utils/slideHelpers'
import { ContentWithNavigation } from '../ContentWithNavigation'

import type { ABTestConfig } from '../newContentTestConfig'

type Props = {
  reportImages: Array<string>
  currentConversationIndex: number
  isEducationStarted: boolean
  currentSlideIndex: number
  isManualMode: boolean
  config: ABTestConfig
  onNavigate: (direction: 'prev' | 'next') => void
  onComplete?: () => void
}

export const ReportImagesSlider = ({
  reportImages,
  currentConversationIndex,
  isEducationStarted,
  currentSlideIndex,
  isManualMode,
  config,
  onNavigate,
  onComplete,
}: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const asset = useAsset('/assets/phishing-first-time-lister-education')
  const shouldShowProgressBar = isEducationStarted && reportImages.length > 1

  return (
    <>
      <ContentWithNavigation
        currentIndex={currentConversationIndex}
        maxIndex={reportImages.length - 1}
        onNavigate={onNavigate}
        testId="report"
        progressBar={
          shouldShowProgressBar ? (
            <TimerProgressBar
              key={`progress-${currentConversationIndex}-${reportImages.length}`}
              duration={getDurationForExample(currentSlideIndex, currentConversationIndex, config)}
              isActive={!isManualMode}
              reset={false}
              totalCount={reportImages.length}
              currentIndex={currentConversationIndex}
              isManualMode={isManualMode}
              onComplete={onComplete}
            />
          ) : undefined
        }
      >
        <ConversationExample
          reportImage={asset(reportImages[currentConversationIndex] || 'report-1.png')}
          showSpacer={false}
        />
      </ContentWithNavigation>
      {currentConversationIndex === 1 && (
        <div className="phishing-first-time-lister-education__report-cell">
          <Cell
            title={translate('education_screen_3.report')}
            theme="transparent"
            prefix={<Icon name={Flag24} color={Icon.Color.Warning} />}
            aria={{ 'aria-label': translate('a11y.report_images') }}
          />
        </div>
      )}
    </>
  )
}
